import { Card } from '../components/ui/cards'
import { Users, Wrench, Building2 } from "lucide-react";

export const RoleBasedUseCases = () => {
  const roles = [
    {
      title: "Operations Managers",
      icon: Users,
      description: "Reduce field time by 40% and cut operational costs with precise asset location.",
      benefits: ["Cost reduction", "Efficiency gains", "Team productivity"],
      link: "/case-studies#operations",
    },
    {
      title: "Field Technicians",
      icon: Wrench,
      description: "Access real-time infrastructure data on any device, even without connectivity.",
      benefits: ["Easy to use", "Offline capability", "Real-time data"],
      link: "/how-it-works#field-access",
    },
    {
      title: "Asset Managers",
      icon: Building2,
      description: "Ensure compliance and maintain accurate asset records with zero ground scanning.",
      benefits: ["Data accuracy", "Compliance", "Remote deployment"],
      link: "/pricing",
    },
  ];

  return (
    <section className="relative py-20 bg-gradient-to-br from-home-accent/10 via-home-accent/5 to-home-background">
      <div className="absolute inset-0 z-10">
        <img
          src="img/Foundat_Hero Pic 1.jpg"
          alt="Infrastructure worker using AR technology"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-home-primary/95 via-home-primary/80 to-home-primary/60 backdrop-blur-sm"></div>
      </div>
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 z-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Built for Your Role
          </h2>
          <p className="text-lg text-white max-w-2xl mx-auto">
            GO-Locate AR™ delivers specific value for every team member in your organization
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {roles.map((role) => (
            <div key={role.title} className="block group">
              <Card className="p-6 h-full transition-all hover:shadow-xl hover:shadow-home-accent/20 hover:-translate-y-1">
                <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-home-accent/20 to-home-primary/20 flex items-center justify-center mb-4 group-hover:from-home-accent/30 group-hover:to-home-primary/30 transition-colors">
                  <role.icon className="flex w-8 h-8 text-home-accent mx-auto" />
                </div>
                <h3 className="text-xl font-bold bg-gradient-to-r from-home-primary to-home-accent bg-clip-text text-transparent mb-6 pb-3 border-b-2 border-home-primary/20">
                  {role.title}
                </h3>
                <p className="text-home-muted-foreground mb-4">{role.description}</p>
                <ul className="space-y-2">
                  {role.benefits.map((benefit) => (
                    <li key={benefit} className="text-sm text-home-muted-foreground flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary"></span>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
